@for (product of products$ | async; track product; let productIndex = $index) { @if (hasProduct(product)) {
<div
  #elementRef
  [ngClass]="['d-flex', 'flex-column', productIndex % 2 ? 'even' : 'odd', 'item-' + product.bomItemNo]"
  [class.active]="isActive(product.bomItemNo)"
  [style.margin-top.px]="
    (isTablet$ | async) && adjustMarginTop(productIndex, product.bomItemNo, elementRef) ? adjustedMarginTopValue : null
  "
  [style.margin-bottom.px]="(isTablet$ | async) && adjustMarginBottom(productIndex, product.bomItemNo, elementRef)"
>
  <div
    [ngClass]="['product', product.code, businessType]"
    [id]="product.bomItemNo"
    (click)="
      toggleSelectedProduct(product.bomItemNo, !isActive(product.bomItemNo)); scrollToFirstProduct(product.bomItemNo)
    "
    [class.active]="isActive(product.bomItemNo)"
    [class.pill-3]="product.bomItemNo.toString().length === 3"
    [class.pill-4]="product.bomItemNo.toString().length === 4"
    [class.pill-5]="product.bomItemNo.toString().length === 5"
    [class.pill-6]="product.bomItemNo.toString().length === 6"
    [class.disabled]="
      (isOutOfStock(product?.code) | async) || !(getDealerPrice(product?.code) | async)?.toString().length
    "
  >
    @if (!(componentService.expandedImageClicked$ | async)) {
    <div class="hotspot-button" [class.invisible]="product.bomItemNo === -1">
      <span
        [class.rounded-circle]="product.bomItemNo.toString().length <= 2"
        [class.pill]="product.bomItemNo.toString().length > 2"
        ><span>{{ product.bomItemNo }}</span>
      </span>
    </div>
    }
    <div class="product-details">
      <span class="sku mr-1">{{ product.code }}</span>
      @switch (checkStockLevel(product.stock?.stockLevel, product.stock?.stockLevelStatus)) { @case ('inStock') {
      <span class="in-stock">{{ 'product.inStock' | cxTranslate }}</span>
      } @case ('outOfStock') {
      <span class="no-stock">{{ 'product.noStock' | cxTranslate }}</span>
      } @case ('discontinued') {
      <span class="discontinued">{{ 'product.discontinued' | cxTranslate }}</span>
      } }
      <span class="text-truncate name" [title]="product.name">{{ product.name }}</span>
      <app-tooltip-text
        class="bomDescription bom"
        [tooltipContent]="getProductBOM(product.code)"
        [content]="getProductBOM(product.code)"
        placement="bottom"
      ></app-tooltip-text>
    </div>
    <button
      mat-icon-button
      class="expand-more rounded-0"
      [disableRipple]="true"
      [class.rotated]="isActive(product.bomItemNo)"
    >
      @if (!(componentService.expandedImageClicked$ | async)) {
      <mat-icon [attr.test]="'testvariable'">expand_more</mat-icon>
      }
    </button>
    <div class="line-break"></div>
  </div>
  <div class="collapsible" [class.d-none]="!isActive(product?.bomItemNo)" [class.show]="isActive(product?.bomItemNo)">
    <ng-container
      [ngTemplateOutlet]="productDetailsMore"
      [ngTemplateOutletContext]="{ product: product }"
    ></ng-container>
  </div>
</div>
} }
<ng-template #productDetailsMore let-product="product">
  <div class="product-details-more">
    <div
      class="prices"
      [ngClass]="activeLanguage$ | async"
      [class.gst-labels-on]="(showGstInclusive$ | async) || (showGstExclusive$ | async)"
    >
      <div class="srpPrice">
        <span>{{ 'product.productList.srp' | cxTranslate }}</span>
        <span>{{ getSrpPrice(product?.code) | async }}</span>
        @if ((getSrpPrice(product?.code) | async) && showGstInclusive$ | async) {
        <span class="gst-label">{{ 'gst.inclusive' | cxTranslate }}</span>
        }
      </div>
      @if (!showSrpOnly) { @if (!basepriceHidden) {
      <div class="basePrice">
        <span>{{ 'product.productList.basePrice' | cxTranslate }}</span>
        <span>{{ getBasePrice(product?.code) | async }}</span>
        @if ((getBasePrice(product?.code) | async) && showGstExclusive$ | async) {
        <span class="gst-label">{{ 'gst.exclusive' | cxTranslate }}</span>
        }
      </div>
      }
      <div class="dealerPrice">
        <span>{{ 'product.productList.dealerPrice' | cxTranslate }}</span>
        @if (!dealerPrice(product?.code)) {
        <div class="spinner-shimano-wrapper-dp">
          @if (this.hasDealerPrice) {
          <div class="spinner-shimano ev">
            <div></div>
          </div>
          } @if (!this.hasDealerPrice) {
          <span class="no-dealer-price no-dealer-price-ev"></span>
          }
        </div>
        } @else {
        <span>{{ getDealerPrice(product?.code) | async }}</span>
        @if (dealerPrice(product?.code) && showGstExclusive$ | async) {
        <span class="gst-label">{{ 'gst.exclusive' | cxTranslate }}</span>
        } }
      </div>
      }
    </div>
    <div class="actions">
      <div class="pdp">
        @if (isDesktop) { @if (product && !isPlpPopupEnabled) {
        <button
          mat-icon-button
          class="assignment rounded-0"
          [disableRipple]="true"
          matTooltip="{{ 'buttonTooltip.plp.pdpButton' | cxTranslate }}"
          [matTooltipDisabled]="!deviceDetectorService.isDesktop()"
          attr.aria-label="{{ 'buttonTooltip.plp.pdpButton' | cxTranslate }}"
          [routerLink]="{ cxRoute: 'product', params: product } | cxUrl"
        >
          <mat-icon>assignment</mat-icon>
        </button>
        } @if (isPlpPopupEnabled) {
        <div [ngTemplateOutlet]="detailsButton"></div>
        } } @else { @if (product && !isPlpPopupEnabled) {
        <button
          mat-icon-button
          class="assignment rounded-0"
          [disableRipple]="true"
          attr.aria-label="{{ 'buttonTooltip.plp.pdpButton' | cxTranslate }}"
          [routerLink]="{ cxRoute: 'product', params: product } | cxUrl"
        >
          @if (!isPlpPopupEnabled) {
          <mat-icon>assignment</mat-icon>
          }
        </button>
        } @if (isPlpPopupEnabled) {
        <div [ngTemplateOutlet]="detailsButton"></div>
        } }

        <ng-template #detailsButton>
          <div class="details-button-pdp">
            <button
              class="details-button secondary-btn btn-block btn"
              type="button"
              matTooltip="{{ 'buttonTooltip.plp.pdpButton' | cxTranslate }}"
              [matTooltipDisabled]="!deviceDetectorService.isDesktop()"
              attr.aria-label="{{ 'buttonTooltip.plp.pdpButton' | cxTranslate }}"
              [routerLink]="{ cxRoute: 'product', params: product } | cxUrl"
            >
              {{ 'buttonTooltip.plp.pdpDetailsButton' | cxTranslate }}
            </button>
          </div>
        </ng-template>
      </div>
      @if (product) {
      <div class="add-to-cart" [formGroup]="explodedViewFormGroup">
        <div class="quantity">
          <fieldset
            [disabled]="
              (isOutOfStock(product?.code) | async) || !(getDealerPrice(product?.code) | async)?.toString().length
            "
          >
            <input
              #quantityInput
              class="form-control"
              type="number"
              min="0"
              oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); this.value = this.value.replace(/^[0]+/g,'')"
              maxlength="3"
              [formControlName]="product?.code"
              (change)="checkInput($event, product?.code)"
            />
          </fieldset>
        </div>
        @if (isDesktop) {
        <button
          mat-icon-button
          [ngClass]="'sku-' + [product.code]"
          class="add-to-cart-primary rounded-0"
          [disableRipple]="true"
          matTooltip="{{ 'buttonTooltip.addToCart.title' | cxTranslate }}"
          [matTooltipDisabled]="!deviceDetectorService.isDesktop()"
          attr.aria-label="{{ 'buttonTooltip.addToCart.title' | cxTranslate }}"
          (click)="backorderCartCheck(product)"
          [disabled]="
            !quantityInput.value ||
            (isOutOfStock(product?.code) | async) ||
            !(getDealerPrice(product?.code) | async)?.toString().length ||
            showSpinner
          "
        >
          <mat-icon svgIcon="add-to-cart-primary" [inline]="true"></mat-icon>
        </button>
        } @else {
        <button
          mat-icon-button
          [ngClass]="'sku-' + [product.code]"
          class="add-to-cart-primary rounded-0"
          [disableRipple]="true"
          attr.aria-label="{{ 'buttonTooltip.addToCart.title' | cxTranslate }}"
          (click)="backorderCartCheck(product)"
          [disabled]="
            !quantityInput.value ||
            (isOutOfStock(product?.code) | async) ||
            !(getDealerPrice(product?.code) | async)?.toString().length ||
            showSpinner
          "
        >
          <mat-icon svgIcon="add-to-cart-primary" [inline]="true"></mat-icon>
        </button>
        }
      </div>
      }
    </div>
  </div>
</ng-template>
